import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import {withRouter} from "react-router";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../customers/forms/ShippingAddressForm";
import {GET_ORDER_DELIVERY_ADDRESS_FOR_EDIT} from "../../queries/shipping";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeDeliveryAddress} from "../../actions/ShippingApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, isUS} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateShippingAddress} from "../../lib/AddressValidation";
import {coerceBoolean} from "../../components/forms/BooleanInputField";

function validateForm(values, props) {
  return validateShippingAddress(values).toJS();
}

class ChangeDeliveryAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.orderId)
                              .set("skipAddressValidation", coerceBoolean(values.get("skipAddressValidation")));
    
    return this.props.changeOrderShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.changeOrderShippingAddress.errors.length <= 0) {
          this.props.cancelChangeDeliveryAddress();
        } else {
          let errors = createValidationErrors(response.data.changeOrderShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeDeliveryAddress();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.countriesAvailableForShippingOrder);
    let shippingOrder = fromJS(data.shippingOrder);
    let deliveryAddress = shippingOrder.get("deliveryAddress");
    let initialValues = fromJS({
      type: deliveryAddress.get("type"),
      name: deliveryAddress.get("name"),
      attName: deliveryAddress.get("attName"),
      phoneNr: deliveryAddress.get("phoneNr"),
      email: deliveryAddress.get("email", ""),
      addressAddressLine1: deliveryAddress.get("addressAddressLine1"),
      addressAddressLine2: deliveryAddress.get("addressAddressLine2"),
      addressCity: deliveryAddress.get("addressCity"),
      addressPostcode: deliveryAddress.get("addressPostcode"),
      addressStateProvince: deliveryAddress.get("addressStateProvince"),
      addressCountryCode: deliveryAddress.get("addressCountryCode"),
      addressCountryName: deliveryAddress.get("addressCountryName")
    })  
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        usStates={getUSStates()}
        initialValues={initialValues}
        showAttentionName={true}
        showUSStates={this.props.showUSStates}
        showStateProvince={this.props.showStateProvince}
        showPhoneNr={true}
        showEmail={true}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CHANGE_ORDER_SHIPPING_ADDRESS = gql`
  mutation changeOrderShippingAddress($data: OrderShippingAddressInput!) {
    changeOrderShippingAddress(input: $data) {
      errors { key message }
    }
  }
`;

const withAddressQuery = compose(
  graphql(GET_ORDER_DELIVERY_ADDRESS_FOR_EDIT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }      
    })
  }),
  graphql(CHANGE_ORDER_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      changeOrderShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const ChangeDeliveryAddressFormContainerWithData = withAddressQuery(ChangeDeliveryAddressFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelChangeDeliveryAddress})(withRouter(ChangeDeliveryAddressFormContainerWithData));